import GuestLayout from '@/layouts/GuestLayout.vue'

export default [
  {
    path: '/',
    name: 'login',
    component: () => import('@/views/login/LoginView.vue'),
    meta: {
      requiresAuth: false,
      layout: GuestLayout
    },
    alias: '/login'
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: () => import('@/views/login/ForgotPassword.vue'),
    meta: {
      requiresAuth: false,
      layout: GuestLayout
    }
  },
  {
    path: '/reset-password',
    name: 'resetPassword',
    component: () => import('@/views/login/ResetPasswordView.vue'),
    meta: {
      requiresAuth: false,
      layout: GuestLayout
    }
  },
  {
    path: '/confirmation-account',
    name: 'confirmationAccount',
    component: () => import('@/views/login/ConfirmationAccountView.vue'),
    meta: {
      requiresAuth: false,
      layout: GuestLayout
    }
  }
]
